import './index.css';
import TinderCard from 'react-tinder-card';
import { View, Text } from '../../../component';
import { isDesktopBrowser } from '../../../utilities/helper';
import Constants from '../../../constants';
import { s, vs, ms } from '../../../utilities/scaling_utils';
import { BsInfoCircleFill } from 'react-icons/bs';
import IconButton from '@mui/material/IconButton';
import React from 'react';

interface Props {
  tinderCardRef?: any;
  index?: any;
  questionItem?: any;
  onSwipe?: any;
  language?: any;
  onPressInfo?: any;
}

const YNQuestionCard = ({
  tinderCardRef,
  index,
  questionItem,
  onSwipe,
  language = 'en',
  onPressInfo
}: Props) => {
  const { questions = {} } = questionItem;
  const { english: en = '', hindi: hi = '' } = questions;
  const question = language === 'en' ? en : hi;

  const onSwipe_ = (dir: any) => {
    onSwipe(dir, questionItem.playerName, index);
  };

  return (
    <TinderCard
      ref={tinderCardRef}
      className="YNQuestionCard__swipe"
      key={questionItem._id}
      onSwipe={onSwipe_}
      preventSwipe={['up', 'down']}>
      <View
        style={{
          width: isDesktopBrowser ? '550px' : '100%'
        }}
        className="YNQuestionCard__wrapper">
        <View
          style={{
            width: isDesktopBrowser ? s(200) : s(280),
            height: vs(220),
            backgroundImage: `url(${Constants.Images.QuestionBG})`,
            padding: '10px'
          }}
          className={'YNQuestionCard__container'}>
          <IconButton
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              padding: 5
            }}
            onTouchStart={onPressInfo}
            onClick={onPressInfo}>
            <BsInfoCircleFill size={30} color={'#2a2728'} />
          </IconButton>
          <img
            style={{
              position: 'absolute',
              bottom: 0
            }}
            src={questionItem.imageUrl}
            width={s(160)}
            height={vs(180)}
          />
          {questionItem.isPowerUp && (
            <View
              style={{
                position: 'absolute',
                right: s(-20),
                top: vs(-20)
              }}>
              <Constants.Svgs.YesNo_2xBtnSelect width={s(40)} height={s(40)} />
            </View>
          )}
        </View>
        <View
          style={{
            marginTop: vs(-10),
            height: vs(100),
            zIndex: 0
          }}
          className={'YNQuestionCard__questionContainer'}>
          <img src={Constants.Images.QuestionTitleBG} className={'stretch'} />
          <View
            style={{
              height: vs(100)
            }}
            className="YNQuestionCard__questionWrapper">
            <Text
              style={{
                fontSize: isDesktopBrowser ? '1.5rem' : ms(15)
              }}
              className="YNQuestionCard__question">
              {question}
            </Text>
          </View>
        </View>
        <View
          style={{
            marginTop: vs(-10),
            width: isDesktopBrowser ? s(200) : s(280),
            height: vs(60),
            backgroundImage: `url(${Constants.Images.QuestionBG})`,
            backgroundSize: 'cover',
            borderWidth: '10px',
            borderStyle: 'solid',
            borderColor: '#2a2728',
            borderRadius: '10px',
            borderTopWidth: '0px',
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px'
          }}
        />
      </View>
    </TinderCard>
  );
};
export default React.memo(YNQuestionCard);
